// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__3FXDa","approved":"Status_approved__2PqSv","rejected":"Status_rejected__l7YR9","expired":"Status_expired__3qcFc","label":"Status_label__2_IS2"};